import React, { useState, useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Drawer, ScrollBox } from '@agencypmg/alli';
import DrawerMenu from './DrawerMenu';
import ClientSelectorHeader from './ClientSelectorHeader';
import SelectedClient from './SelectedClient';

export default function ClientSelector({
    clients,
    currentClient,
    changeClient,
}) {
    const [show, setShow] = useState(false);
    const toggleDrawer = useCallback(() => setShow(!show), [show, setShow]);

    const [filteredClients, setFilteredClients] = useState(null);

    const onMenuItemClick = useCallback(
        client => {
            setShow(false);
            changeClient(client.slug);
            setFilteredClients(null);
        },
        [changeClient, setShow, setFilteredClients],
    );

    if (clients.length === 0) {
        return 'No Assigned Clients';
    }

    return (
        <>
            <SelectedClient
                onClick={() => setShow(!show)}
                clientName={currentClient?.name}
            />

            <Drawer
                show={show}
                toggleDrawer={toggleDrawer}
                zIndex="z-50"
                bodyFullHeight={true}
                wrapperClass="client-selector"
                overlay
            >
                <ScrollBox
                    header={
                        <ClientSelectorHeader
                            onClose={toggleDrawer}
                            clients={clients}
                            setFilteredClients={setFilteredClients}
                        />
                    }
                >
                    <div className="pt-8 w-full">
                        <DrawerMenu
                            clients={filteredClients || clients}
                            currentClient={currentClient}
                            onMenuItemClick={onMenuItemClick}
                        />
                    </div>
                </ScrollBox>
            </Drawer>
        </>
    );
}

ClientSelector.propTypes = {
    changeClient: PropTypes.func,
};
